import { SettingsObject } from '@hooks/useSettings';

export const defaults: Partial<SettingsObject> = {
    currency: 'SEK',
    enableEnergyLabelLink: true,
    isOmnibusLPPCombined: true,
};
